import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions/logout';
import {MESSAGE_EVENT_TYPE} from "../../constants/postMessages";
import './index.scss';
import {getApplianceUrl, getSessionToken} from "../../actions/storage";

export class Logout extends Component {
  logout = (e) => {
    if (e.source === window.parent && e.origin === getApplianceUrl() && getSessionToken()) {
      this.props.logout();
    }
  }

  componentDidMount() {
    window.addEventListener(MESSAGE_EVENT_TYPE, this.logout);
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.logout);
  }

  render() {
    return (<div/>);
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(actions.logout());
    }
  }
};

export default connect(
    null,
    mapDispatchToProps
)(Logout);
